<template>
    <b-card no-body class="w-100 mb-3 bottom-navigation">
        <b-card-body class="pt-1 pb-1">
            <b-button v-if="displayBack" class="pl-0" variant="link" :to="{ name: 'lottery', params: { gameId } }"><fa-icon icon="chevron-left"/> {{ 'back_to_game' | lang }}</b-button>
            <b-button class="pl-0" variant="link" :to="{ name: 'tutorial' }">{{ 'how_to_play' | lang }}</b-button>
            <b-button variant="link" :to="{ name: 'results', params: { gameId } }">{{ 'results' | lang }}</b-button>
            <b-button v-if="isLogged" variant="link" :to="{ name: 'tickets', params: { gameId } }">{{ 'history_of_tickets' | lang }}</b-button>
        </b-card-body>
    </b-card>
</template>

<script>
import Axios from 'axios';
import lang from '@tv/filters/lang';
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState(['isLogged']),

      gameId() {
          return this.$route.params.gameId || Config.game_id;
      },

      displayBack() {
          if (this.$route.name === 'lottery') {
            return false;
          }

          if (Config.display_navigation) {
            return false;
          }

          return true;
      },
    },
    methods: {
    },
}
</script>
